import { useSendBuilderRfq } from './send-drfq';
import { useSendBuilderOB } from './send-grfq';

export function useSend(isOrderBook: boolean) {
  const rfq = useSendBuilderRfq();
  const ob = useSendBuilderOB();

  return isOrderBook ? ob : rfq;
}
